"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Links = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importDefault(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var tags_ga_1 = require("../../utils/tags-ga");
var styles_1 = require("./styles");
var Links = function (_a) {
    var gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, id = _a.id, className = _a.className, icon = _a.icon, label = _a.label, onClick = _a.onClick, ariaLabel = _a.ariaLabel, ariaHaspopup = _a.ariaHaspopup, titleAccess = _a.titleAccess, gaEventType = _a.gaEventType, props = __rest(_a, ["gaCategory", "gaAction", "gaLabel", "id", "className", "icon", "label", "onClick", "ariaLabel", "ariaHaspopup", "titleAccess", "gaEventType"]);
    var theme = (0, temas_frontend_1.useTheme)().theme;
    return (react_1.default.createElement(styles_1.LinkSectionStyled, { id: id, className: className },
        react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: gaEventType },
            react_1.default.createElement(styles_1.LinkButtonStyled, __assign({ "aria-label": ariaLabel, "aria-haspopup": ariaHaspopup, "title-access": titleAccess, onClick: onClick }, props),
                icon,
                react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, bold: true, color: theme.grey001, className: "linksLabel" }, label)))));
};
exports.Links = Links;
